import {
  COMPENSATION_PRODUCT_ID,
  GOVERNANCE_PRODUCT_ID,
  PRODUCT_MEMBERSHIP_FULL,
  PRODUCT_MEMBERSHIP_TRIAL,
} from '../../shared/constants/product-access-constants';

export { COMPENSATION_PRODUCT_ID, GOVERNANCE_PRODUCT_ID };

/**
 * Returns membership status for a product from cached userInfo, or null if absent.
 */
export function getCachedMembershipStatusForProduct(productId: number): number | null {
  try {
    const cached = window.localStorage.getItem('userInfo');
    if (!cached) return null;
    const parsed = JSON.parse(cached) as { MemberShip?: Array<{ product_id: number; status?: number }> };
    const membership = parsed.MemberShip?.find((m) => m.product_id === productId);
    if (!membership) return null;
    return membership.status ?? null;
  } catch {
    return null;
  }
}

export function hasProductMembershipAccess(productId: number): boolean {
  const status = getCachedMembershipStatusForProduct(productId);
  return status === PRODUCT_MEMBERSHIP_TRIAL || status === PRODUCT_MEMBERSHIP_FULL;
}
